import React from "react";
import "./index.css";
import HeadSection from "../../components/head";
import Article from "../../components/handbook";
import WorkDone from "../../components/work";
import ContactForm from "../../components/contact";
import SocialMedia from "../../components/socials";
import Footer from "../../components/foot";


function MainPage(){

	return(
		<React.Fragment>			
			<HeadSection />

			<main>
				
				<section id="my-about" >
					<h2 className='rock' data-aos="zoom-in-down" data-aos-duration="500"> ABOUT ME </h2>
					<p className="pleasing"> 
						Hi I'm <span className="arts">Ibrahim</span>. I am a Freelancing Full Stack Web developer, creator of 
						<span className="arts"> all stuff internet and fantastic</span>. I am a 23 year old self-taught developer
						and a first class 'nautical science' graduate (which has nothing to do with computers, by the way!). However,
						I have always enjoyed the creative side of developers and day after day, I strive hard to improve
						my competency in web & mobile development and in artificial intelligence...
					</p>
					
					<div className="btn-gp">
						<a href="/about/" className='enchanted' > More about me </a>
						<a href="/service/" className='sedated' > My freelancing services </a>
					</div>

				</section>


				<section id="can-do">
					<h2 className='rock'> What I Can Do For You! </h2>

					<Article />

					<div className="btn-gp">
						<a href="#contact-me" className='enchanted' > Contact Me </a>
						<a href="/service/" className='sedated' > My freelancing services </a>
					</div>

				</section>

				<section id='previous-work'>
					<h2 className='rock'> Work History </h2>

					<WorkDone />

					<div className="btn-gp">
						<a href="/service/" className='enchanted' > My Freelancing Services </a>
						<a href="#contact-me" className='sedated' > {"Let's make something happen"} </a>
					</div>

				</section>

				<ContactForm />

				<SocialMedia />

			</main>

			<Footer />

		</React.Fragment>
		)
}

export default MainPage;